module.exports = __webpack_public_path__ + "img/guarantee-img.9e809885.png";